// @ts-check
import { requestTimeout } from '@/partials/el.Utils.js';

elabs.OverlayMenuService = class {
  constructor() {
    this.activeWrapperClass = null;
    this.isClosing = false;
  }

  initialise = () => {
    document.querySelectorAll('.el-overlay-menu__close-button, .el-overlay-menu__background').forEach((el) => {
      el.addEventListener('click', () => this.closeMenu(), { once: false });
    });
    this.isInitialised = true;
  };

  /**
   * @param {object} options
   * @param {string} [options.templateId]
   * @param {string} [options.htmlContent]
   * @param {'left'|'right'} [position='right']
   * @param {object} [config={}]
   */
  showMenu = (options = {}, position = 'right', config = {}) => {
    if (!this.isInitialised) {
      this.initialise();
    }
    let menuPositionClass = 'el-overlay-menu-open--right';
    if (position === 'left') {
      menuPositionClass = 'el-overlay-menu-open--left';
    }

    const menuWrapperElement = document.querySelector('.el-overlay-menu');
    const menuBodyElement = document.querySelector('.el-overlay-menu__body');
    if (!(menuBodyElement instanceof HTMLElement) || !(menuWrapperElement instanceof HTMLElement)) {
      throw new Error('Missing .el-overlay-menu or .el-overlay-menu__body');
    }

    if (config.wrapperClass) {
      this.activeWrapperClass = config.wrapperClass;
      menuWrapperElement.classList.add(this.activeWrapperClass);
    }

    let menuBodyHtml = '';
    if (options.htmlContent) {
      menuBodyHtml = options.htmlContent;
    } else if (options.templateId) {
      const menuBodyTemplateElement = document.getElementById(options.templateId);
      if (!menuBodyTemplateElement) {
        console.warn('No template was found for the menu');
        return;
      }
      menuBodyHtml = menuBodyTemplateElement.innerHTML;
    }

    menuBodyElement.innerHTML = menuBodyHtml;
    elabs.Bootstrap.initialiseTooltips('.el-overlay-menu__body *[data-tippy-content]');
    document.body.classList.add(menuPositionClass);
    requestAnimationFrame(() => {
      // when initial position is ready, THEN begin the appearance animation
      document.body.classList.add('el-overlay-menu-open');
    });
  };

  closeMenu = () => {
    if (this.isClosing) {
      return;
    }
    this.isClosing = true;

    const executeClose = () => {
      document.dispatchEvent(new CustomEvent('overlay:closing'));
      document.body.classList.remove('el-overlay-menu-open');

      requestTimeout(() => {
        // clean up the DOM
        if (!document.body.classList.contains('el-overlay-menu-open')) {
          const menuBodyElement = document.querySelector('.el-overlay-menu__body');
          if (menuBodyElement) {
            menuBodyElement.innerHTML = '';
          }

          const menuWrapperElement = document.querySelector('.el-overlay-menu');

          if (this.activeWrapperClass) {
            if (menuWrapperElement) {
              menuWrapperElement.classList.remove(this.activeWrapperClass);
            }
            this.activeWrapperClass = null;
          }

          menuWrapperElement?.classList.remove('el-overlay-menu--wide');
          document.body.classList.remove('el-overlay-menu-open--right', 'el-overlay-menu-open--left');
        }
        document.dispatchEvent(new CustomEvent('overlay:closed'));
        this.isClosing = false;
      }, 300);
    };

    const menuWrapperElement = document.querySelector('.el-overlay-menu');
    document.dispatchEvent(new CustomEvent('overlay:closing:start'));
    if (menuWrapperElement && menuWrapperElement.classList.contains('el-overlay-menu--cart')) {
      setTimeout(executeClose, 200);
    } else {
      executeClose();
    }
  };
};

elabs.onJavascriptReady(() => {
  elabs.overlayMenuService = new elabs.OverlayMenuService();
});
